




import React, { useContext, useEffect, useState, Fragment } from "react";
// import './Integration.css';
import styled from "styled-components";
import { XbeContext } from "./../CardsPage";
import { withRouter } from "react-router-dom";
import { Login } from "./Login";
import { FormGroup, Textarea, Button, Icon, Select, Input } from 'xsolla-uikit';
import MaterialIcon from 'material-icons-react';


function CardLanding1(props) {
  const context = useContext(XbeContext);
  // onClick={()=>props['history'].push(`?filters=${context["filters"].toString()}`)}

  const {
    step = 0,

    language = "en",

    appearance = "l",
    utm,
    id = 2051,
    salesCardId = 8,
    imageUrl,
    badgeText,
    title,
    description,
    learnMoreUrl,
    integrationTimeText,
    callToAction = "Get started",
    proposalText,
    postponed,
    project_id,
    project_name,
  } = { ...props };

  useEffect(() => {
    if (context && context["salesCards"].length) {
      let cardData = context["salesCards"].filter(
        (one) => one["fields"]["salesCardId"] === props["salesCardId"]
      )[0];
      if (cardData) {
        const {
          language = "en",

          appearance = "l",
          utm,
          id = 2051,
          salesCardId = 8,
          imageUrl,
          badgeText,
          title,
          description,
          learnMoreUrl,
          integrationTimeText,
          callToAction = "Get started",
          proposalText,
          postponed,
          project_id,
          project_name,
        } = { ...cardData["fields"] };
      }
    }
  }, [context]);

  const { filters } = { ...context };

  const [pa, setPa] = useState(step);

  const [login, setLogin] = useState();

  const [pa2, setPa2] = useState(pa);

  useEffect(() => {
    if (pa !== pa2 && !pa2) {
      setTimeout(() => {
        setPa2(pa);
      }, 200);
    } else {
      setPa2(pa);
    }
  }, [pa]);

  return (
    <CssEmailBody>
      <div className="c_email_cols">

        {/* PREVIEW */}
        {/* <div className="int_iframe0"> */}

<div className="c_onepager_preview_pdf"
  style={{
    maxWidth:"100%",
  }}
>
          <style
            dangerouslySetInnerHTML={{
              __html:
                "\n#guide-menu {\ndisplay: none !important;\n}\n.all-site-wrap {\ndisplay: block !important;\n}\n",
            }}
          />



          <iframe
            // className={`int_iframe ${pa && parseInt(pa) === 1 ? 'int_iframe--step-hide' : ''}`}

            src={learnMoreUrl}
            width="100%"
          ></iframe>

          </div>




        {/* CODE */}
        <div className="c_emails_code">
          <div style={{position: 'sticky', top: 40}}>



          <FormGroup>
            <FormGroup label="Landing page">
              <SelectPa>
                <AdminTag>{title}</AdminTag>
              </SelectPa>

              {/* <Select
                  name="basic"
                  input={{
                    value: 'james',
                    onChange: ()=>void(0)
                  }}
                  options={[{
                    label: 'James',
                    value: 'james',
                  },{
                    label: 'Sam Gaglani',
                    value: 'sam',
                  }]}
                /> */}
            </FormGroup>
          </FormGroup>


          <FormGroup label="Actions">
            <FormGroup indentation='lg'>
              <Button appearance="flatten" size="sm">
                <MaterialIcon
                  color="currentColor"
                  size="15"
                  icon="edit"
                />
                &nbsp;&nbsp;Request edits
              </Button>
            </FormGroup>
          </FormGroup>

          <FormGroup label="Links">

            <FormGroup indentation='lg'>
              <Button appearance="flatten" size="sm">
                <MaterialIcon
                  color="currentColor"
                  size="15"
                  icon="link"
                />
                &nbsp;&nbsp;JIRA ticket
              </Button>
            </FormGroup>

            </FormGroup>


        </div>
        </div>
      </div>
    </CssEmailBody>
  );
}

export const CardLanding = withRouter(CardLanding1);

const CssEmailBody = styled.div`
  padding-top: 60px;
  position: relative;
  display: flex;
  justify-content: center;
  align-items: flex-start;
  padding-top: 80px;
  background: #eff5ff;
  min-height: 100vh;
  z-index: 1000000;
`;

export const IntMarkAsDone = () => {
  return (
    <div className="p_x_doc0">
      <div className="p_x_doc">
        <div className="p_x_doc_b">
          <div className="p_button p_button--appearance-white">
            <div>mark as done</div>
          </div>
          <div className="l_line">
            This step requires you to follow the documentation
          </div>
        </div>
      </div>
    </div>
  );
};



export const SelectPa = ({children, icon}) => {
  return(<div className="xsui-select">
  <div className="xsui-dropdown">
    <div style={{ display: "block" }}>
      <div
        style={{
          position: "relative",
          width: "100%",
          display: "block",
        }}
      >
        <button
          name="item_type"
          value="Default"
          placeholder="Select"
          className="xsui-input xsui-input--size-md xsui-input--appearance-primary xsui-input--offset-right xsui-input--read-only"
          type="button"
          data-id="item_type"
          data-value="Default"
        >
          {children}
        </button>
        <div className="xsui-input__icon">
          <MaterialIcon
            color="currentColor"
            size="16"
            icon={typeof icon === 'text' ? icon : 'unfold_more'}
          />
        </div>
      </div>
      <div className />
    </div>
    <div />
  </div>
</div>)
}

export const AdminTag = ({children, icon}) => {
  return(<Fragment>
<span style={{
    backgroundColor: '#f7faff',
    border: '1px solid #c5d0db',
    padding: '0.2em 0.8em',
    borderRadius: 5
    }}>{children}</span>
</Fragment>)
}